import { render, staticRenderFns } from "./prueba-de-manejo.vue?vue&type=template&id=3cb2290e&"
import script from "./prueba-de-manejo.vue?vue&type=script&lang=ts&"
export * from "./prueba-de-manejo.vue?vue&type=script&lang=ts&"
import style0 from "./prueba-de-manejo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports